import useAsyncData from "../../../hooks/use-async-data";
import gpsService from "../gps.service";
import GpsPlanEntryRecords from "./gps-plan-entry-records";
import GpsPlanEntryRecordsParams from "./gps-plan-entry-records-params";

const useGpsPlanEntryRecords = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<GpsPlanEntryRecords | null>(null, false);

  const load = async (
    params: GpsPlanEntryRecordsParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const routeCompletedRoute = await gpsService.getPlanEntryRecords(
        params,
        signal,
      );

      setData(routeCompletedRoute);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useGpsPlanEntryRecords;
